import { render, staticRenderFns } from "./TimeSpentOnPageModal.vue?vue&type=template&id=30d5f9b2&"
import script from "./TimeSpentOnPageModal.vue?vue&type=script&lang=js&"
export * from "./TimeSpentOnPageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports